import i18n from 'l10n';

const it = {};
it.init = function (selector) {
    const redeemersHandler = function (json) {
        $(selector).find("#redeemers-title").text(i18n.t("dashboard.redeemersTitle", {count: json}));
        $(selector).find("#redeemers-text").text(json);
        $(selector).show();
    };
    $.getDefaultJSONQ('/CampaignCloud/ApiUser/Redeemers/count', null, redeemersHandler);
};
export default it;
